import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, VuexModule } from 'vuex-module-decorators';

export interface SeoObject {
  seoTitle: string;
  seoDescription: string;
  seoKeywords: string;
  seoSlug: string;
  seoCanonicalUrl: string;
  seoImageAlt: string;
  seoNoIndex: boolean;
  seoNoFollow: boolean;
  seoCustomMeta: any;
  seoSchema: any;
  source: string;
}

@Module
export default class SeoModule extends VuexModule {
  seo = [] as Array<SeoObject>;

  @Action
  [Actions.CREATE_SEO_CONFIGURATION]({ data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.post(`/seo`, data).catch(({ response }) => {
      this.context.commit(Mutations.SET_ERROR, {
        [response.statusText]: [response.data.message],
      });
    });
  }

  @Action
  [Actions.UPDATE_SEO_CONFIGURATION]({ entityType, entityId, lang, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.put(
      `/seo/${entityType}/${entityId}?lang=${lang}`,
      data
    ).catch(({ response }) => {
      this.context.commit(Mutations.SET_ERROR, {
        [response.statusText]: [response.data.message],
      });
    });
  }

  @Action
  [Actions.GET_SEO_CONFIGURATION]({ entityType, entityId, lang }) {
    const params = {
      lang: lang,
    };
    ApiService.setAuthorizationHeader();
    return ApiService.query(`seo/${entityType}/${entityId}`, { params });
  }

  @Action
  [Actions.GET_MAIN_PAGES_SEO](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/main-pages-seo', id);
  }

  @Action
  [Actions.UPDATE_MAIN_PAGES_SEO]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/main-pages-seo', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_METATAGS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.CREATE_MAIN_PAGE_SEO](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/main-pages-seo', data)
      .then(() => {
        this.context.commit(Mutations.RESET_METATAGS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }
}
